import React from 'react';
import logoagh from '../img/organizers/logo-agh.png';
import logoifj1 from '../img/organizers/logo-ifj1.png';
import logookptf from '../img/organizers/logo-okptf.png';
import logopk2 from '../img/organizers/logo-pk2.png';
import logoptf from '../img/organizers/logo-ptf.png';
import logouj1 from '../img/organizers/logo-uj1.png';
import logoup from '../img/organizers/logo-up.png';
import logous from '../img/organizers/logo-us.png'

export const Footer = props => {
    return (
        <React.Fragment>
            <div className="footer">
                <img src={logoptf} alt="Polskie Towarzystwo Fizyczne" />
                <img src={logookptf} alt="OKPTF" />
                <img src={logouj1} alt="UJ" />
                <img src={logoagh} alt="AGH" />
                <img src={logoifj1} alt="IFJ" />
                <img src={logoup} alt="UP" />
                <img src={logopk2} alt="PK" />
                <img src={logous} alt="UŚ" />

            </div>
            <div className="footer blockquote-footer">
                Zadanie finansowane w ramach umowy 933/P-DUN/2019 ze środków Ministra Nauki i Szkolnictwa Wyższego przeznaczonych na działalność upowszechniającą naukę.
     </div>
        </React.Fragment>
    );
};
Footer.propTypes = {
};
